/**
 * 저작권 침해내역 신고
 * @param dto CreateCopyrightByUserDTO
 * @returns Promise<CreateCopyrightByUserResponseDTO>
 */ export class CreateCopyrightByUserCommand {
    execute(dto) {
        const url = "/copyright";
        return this.apiService.fetch(url, {
            method: "POST",
            data: dto
        }).then((res)=>res.data);
    }
    constructor(apiService){
        this.apiService = apiService;
    }
}
